import React from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
export function SitemapPage() {
  const {
    lang
  } = useTranslation();
  return <Layout data-id="element-3378">
      <section className="py-16 bg-white" data-id="element-3379">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3380">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-3381">
            Dentico Clinic Sitemap
          </h1>
          <p className="text-lg text-gray-600 mb-12" data-id="element-3382">
            Welcome to Dentico Clinic, Private Dental Clinic in Angel, London
            EC1V.
          </p>

          <div className="space-y-10" data-id="element-3383">
            {/* Main Pages */}
            <div data-id="element-3384">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3385">
                Main Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-3386">
                <li data-id="element-3387">
                  <Link to={`/${lang}`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3388">
                    Home – Private Dentist in Angel, London
                  </Link>
                </li>
                <li data-id="element-3389">
                  <Link to={`/${lang}/about`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3390">
                    About Us – Meet Our Dental Team
                  </Link>
                </li>
                <li data-id="element-3391">
                  <Link to={`/${lang}/contact`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3392">
                    Contact – Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Language Versions */}
            <div data-id="element-3393">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3394">
                Language Versions
              </h2>
              <ul className="space-y-2.5" data-id="element-3395">
                <li data-id="element-3396">
                  <Link to="/en" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3397">
                    🇬🇧 English Version
                  </Link>
                </li>
                <li data-id="element-3398">
                  <Link to="/ua" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3399">
                    🇺🇦 Ukrainian Version
                  </Link>
                </li>
                <li data-id="element-3400">
                  <Link to="/ru" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3401">
                    🇷🇺 Russian Version
                  </Link>
                </li>
              </ul>
            </div>

            {/* Dental Services */}
            <div data-id="element-3402">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3403">
                Dental Services
              </h2>
              <ul className="space-y-2.5" data-id="element-3404">
                <li data-id="element-3405">
                  <Link to={`/${lang}/services`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3406">
                    All Services
                  </Link>
                </li>
                <li data-id="element-3407">
                  <Link to={`/${lang}/services/checkup`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3408">
                    Dental Check-ups
                  </Link>
                </li>
                <li data-id="element-3409">
                  <Link to={`/${lang}/services/hygiene`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3410">
                    Professional Hygiene & Airflow
                  </Link>
                </li>
                <li data-id="element-3411">
                  <Link to={`/${lang}/services/fillings`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3412">
                    White Fillings
                  </Link>
                </li>
                <li data-id="element-3413">
                  <Link to={`/${lang}/services/root-canal`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3414">
                    Root Canal Treatment
                  </Link>
                </li>
                <li data-id="element-3415">
                  <Link to={`/${lang}/services/crowns`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3416">
                    Crowns & Bridges
                  </Link>
                </li>
                <li data-id="element-3417">
                  <Link to={`/${lang}/services/smile-makeover`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3418">
                    Veneers & Smile Makeover
                  </Link>
                </li>
                <li data-id="element-3419">
                  <Link to={`/${lang}/services/extraction`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3420">
                    Tooth Extraction
                  </Link>
                </li>
                <li data-id="element-3421">
                  <Link to={`/${lang}/services/whitening`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3422">
                    Teeth Whitening
                  </Link>
                </li>
                <li data-id="element-3423">
                  <Link to={`/${lang}/services/cosmetic`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3424">
                    Cosmetic Treatments
                  </Link>
                </li>
              </ul>
            </div>

            {/* Specialist Pages (UA) */}
            <div data-id="element-3425">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3426">
                Specialist Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-3427">
                <li data-id="element-3428">
                  <Link to="/ua/ukrainskyi-stomatolog-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3429">
                    🇺🇦 Ukrainian Dentist in London
                  </Link>
                </li>
                <li data-id="element-3430">
                  <Link to="/ua/implanty-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3431">
                    Dental Implants in London (UA)
                  </Link>
                </li>
                <li data-id="element-3432">
                  <Link to="/ua/veneers-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3433">
                    Veneers in London (UA)
                  </Link>
                </li>
                <li data-id="element-3434">
                  <Link to="/ua/root-canal-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3435">
                    Root Canal in London (UA)
                  </Link>
                </li>
                <li data-id="element-3436">
                  <Link to="/ua/emergency-dentist-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3437">
                    Emergency Dentist in Angel (UA)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Blog */}
            <div data-id="element-3438">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3439">
                Blog
              </h2>
              <ul className="space-y-2.5" data-id="element-3440">
                <li data-id="element-3441">
                  <Link to={`/${lang}/blog`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3442">
                    All Articles
                  </Link>
                </li>
                <li data-id="element-3443">
                  <Link to={`/${lang}/blog/dental-implants-cost-london`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3444">
                    Скільки коштують імпланти в Лондоні?
                  </Link>
                </li>
                <li data-id="element-3445">
                  <Link to={`/${lang}/blog/nhs-vs-private-dentistry-uk`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3446">
                    NHS vs Private Dentistry in the UK
                  </Link>
                </li>
                <li data-id="element-3447">
                  <Link to={`/${lang}/blog/dental-treatment-uk-without-insurance`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3448">
                    Лікування зубів у UK без страховки
                  </Link>
                </li>
                <li data-id="element-3449">
                  <Link to={`/${lang}/blog/toothache-london-what-to-do`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3450">
                    Зубний біль у Лондоні — що робити?
                  </Link>
                </li>
                <li data-id="element-3451">
                  <Link to={`/${lang}/blog/veneers-london-everything-you-need-to-know`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3452">
                    Вініри в Лондоні — що потрібно знати
                  </Link>
                </li>
                <li data-id="element-3453">
                  <Link to={`/${lang}/blog/how-to-choose-dentist-angel`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3454">
                    Як обрати стоматолога в Angel
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div data-id="element-3455">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3456">
                Pricing
              </h2>
              <ul className="space-y-2.5" data-id="element-3457">
                <li data-id="element-3458">
                  <Link to={`/${lang}/prices`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3459">
                    Dental Fees – Transparent Private Prices
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-3460">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3461">
                Legal
              </h2>
              <ul className="space-y-2.5" data-id="element-3462">
                <li data-id="element-3463">
                  <Link to={`/${lang}/privacy-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3464">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-3465">
                  <Link to={`/${lang}/cookie-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3466">
                    Cookie Policy
                  </Link>
                </li>
                <li data-id="element-3467">
                  <Link to={`/${lang}/patient-privacy-notice`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3468">
                    Patient Privacy Notice
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-3469">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-gray-600" data-id="element-3470">
              <div className="flex items-center gap-2" data-id="element-3471">
                <MapPin className="w-4 h-4 text-teal-600" data-id="element-3472" />
                <span data-id="element-3473">
                  Dentico Clinic · 360–364 City Road · London EC1V 2PY
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-3474">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-3475">
                <Button size="sm" className="gap-2" data-id="element-3476">
                  <Calendar className="w-4 h-4" data-id="element-3477" />
                  Book Online
                </Button>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-3478">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-3479">
                  <MessageCircle className="w-4 h-4 text-green-600" data-id="element-3480" />
                  WhatsApp
                </Button>
              </a>
              <a href="tel:+447345197820" data-id="element-3481">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-3482">
                  <Phone className="w-4 h-4" data-id="element-3483" />
                  Request a Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}